<template>
    <div class="report_com" :style="{ height: popupHeight }">
        <order-report-detail
            v-if="showDetail"
            :key="detailRenderKey"
            :record="currentRecord"
            :containerHeight="popupHeightNum"
            @back="showDetail = false"
            @reply="handleReply"
            @agree="handleAgree"
            @closeReport="handleCloseReport" />
        <template v-else>
            <div class="report_header">
                <span class="report_title">报备</span>
                <div class="close_icon" @click="close">
                    <van-icon name="cross" color="#999999" size="18" />
                </div>
            </div>
            <div class="report_tabs">
                <div
                    :class="['tab_item', { tab_item_active: currentTab === 0 }]"
                    @click="switchTab(0)">
                    <span :class="['tab_text', { tab_text_active: currentTab === 0 }]">提交报备</span>
                </div>
                <div
                    :class="['tab_item', { tab_item_active: currentTab === 1 }]"
                    @click="switchTab(1)">
                    <span :class="['tab_text', { tab_text_active: currentTab === 1 }]">报备记录</span>
                </div>
            </div>
            <div class="report_body" :style="{ height: bodyHeight + 'px' }">
                <div v-if="currentTab === 0" class="form_scroll" :style="{ height: bodyHeight + 'px' }">
                    <div class="form_content">
                        <div class="form_section">
                            <div class="section_title">报备类型</div>
                            <div class="picker_box" @click="typePickerShow = true">
                                <span :class="reportTypeLabel ? 'picker_value' : 'picker_placeholder'">
                                    {{ reportTypeLabel || '请选择报备类型' }}
                                </span>
                                <van-icon name="arrow-down" color="#999999" size="14" />
                            </div>
                        </div>
                        <div class="form_section" v-if="extraFieldConfig">
                            <div class="section_title">{{ extraFieldConfig.label }}（必填）</div>
                            <div :class="['extra_input_wrap', { extra_input_wrap_suffix: extraFieldConfig.suffix }]">
                                <van-field
                                    v-model="extra"
                                    :placeholder="extraFieldConfig.placeholder"
                                    :type="extraFieldConfig.inputType === 'digit' ? 'number' : 'digit'"
                                    input-align="left" />
                                <span class="extra_suffix" v-if="extraFieldConfig.suffix">{{ extraFieldConfig.suffix }}</span>
                            </div>
                        </div>
                        <div class="form_section" v-if="showReasonAndImages">
                            <div class="section_title">上报原因描述</div>
                            <van-field
                                v-model="remark"
                                rows="3"
                                autosize
                                type="textarea"
                                maxlength="120"
                                placeholder="请输入上报原因"
                                show-word-limit />
                        </div>
                        <div class="form_section" v-if="showReasonAndImages">
                            <div class="section_title_row">
                                <span class="section_title">上报相关图片</span>
                                <span class="section_subtitle">最多上传10张</span>
                            </div>
                            <van-uploader
                                v-model="imageList"
                                multiple
                                :max-count="maxImageCount"
                                :preview-full-image="true" />
                        </div>
                    </div>
                </div>
                <div v-else class="list_panel" :style="{ height: bodyHeight + 'px' }">
                    <div class="list_toolbar">
                        <div
                            :class="['refresh_btn', { refresh_btn_disabled: refreshDisabled, refresh_btn_spinning: listRefreshing }]"
                            @click="handleRefreshList">
                            <van-icon
                                name="replay"
                                :color="refreshDisabled ? '#C0C4CC' : '#357EFE'"
                                size="16"
                                :class="{ spinning: listRefreshing }" />
                            <span :class="['refresh_btn_text', { refresh_btn_text_disabled: refreshDisabled }]">
                                {{ refreshBtnText }}
                            </span>
                        </div>
                    </div>
                    <div class="list_scroll" :style="{ height: listScrollHeight + 'px' }">
                        <div class="list_content">
                            <div
                                class="record_card"
                                v-for="item in recordList"
                                :key="item.id"
                                @click="openDetail(item)">
                                <div
                                    class="record_unread"
                                    v-if="item.is_done != 1 && item.unread > 0">
                                    <span class="record_unread_text">{{ formatUnread(item.unread) }}</span>
                                </div>
                                <div
                                    :class="['record_card_top', {
                                        record_card_top_has_unread: item.is_done != 1 && item.unread > 0
                                    }]">
                                    <span class="record_type">{{ getTypeLabel(item) }}</span>
                                    <div class="record_card_right">
                                        <span
                                            v-if="item.is_done != 1"
                                            class="record_state_text record_state_pending">
                                            处理中
                                        </span>
                                        <span v-else class="record_state_text record_state_done">已完结</span>
                                    </div>
                                </div>
                                <div class="record_card_bottom">
                                    <span class="record_time">{{ item.time }}</span>
                                </div>
                                <img
                                    v-if="item.is_done == 1 && getStatusStamp(item)"
                                    class="record_stamp_img"
                                    :src="getStampImg(item)">
                            </div>
                            <div class="list_empty" v-if="listRefreshing">
                                <van-loading type="spinner" color="#357EFE" size="24px" />
                                <span class="list_empty_text list_refresh_text">刷新中...</span>
                            </div>
                            <div class="list_empty" v-else-if="!listLoading && recordList.length === 0">
                                <span class="list_empty_text">暂无报备记录</span>
                            </div>
                            <div class="list_empty" v-else-if="listLoading">
                                <span class="list_empty_text">加载中...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="report_footer" v-if="currentTab === 0">
                <div class="footer_btn footer_btn_cancel" @click="close">
                    <span class="footer_btn_text footer_btn_cancel_text">取消</span>
                </div>
                <div class="footer_btn footer_btn_submit" @click="submit">
                    <span class="footer_btn_text footer_btn_submit_text">提交</span>
                </div>
            </div>
        </template>
        <van-popup v-model="typePickerShow" round position="bottom" get-container="body">
            <van-picker
                show-toolbar
                title="选择报备类型"
                :columns="reportTypeColumns"
                @confirm="confirmType"
                @cancel="typePickerShow = false" />
        </van-popup>
    </div>
</template>

<script>
import { Toast } from 'vant';
import orderReportDetail from '@/components/orderReport/orderReportDetail.vue';
import {
    reportTypeList,
    getReport,
    createReport,
    reportReply,
    reportContentAgree,
    reportRead,
    reportClose
} from '@/apis/checkList/report.js';
import {
    uploadReportImages,
    formatReportFiles,
    normalizeReportTypes,
    normalizeReportList,
    normalizeReportDetail,
    getReportStatusStamp
} from '@/utils/reportFile.js';

const EXTRA_FIELD_MAP = {
    add_wheel: {
        label: '小轮数量',
        placeholder: '请输入小轮数量（1~4）',
        inputType: 'number',
        validateType: 'integer',
        min: 1,
        max: 4
    },
    price_negotiation: {
        label: '议价价格',
        placeholder: '请输入议价价格',
        inputType: 'digit',
        validateType: 'price',
        suffix: '元'
    },
    add_basement_rescue: {
        label: '地库楼层',
        placeholder: '请输入地库楼层（1~10）',
        inputType: 'number',
        validateType: 'integer',
        min: 1,
        max: 10
    }
};

const HIDE_REASON_IMAGE_TYPES = ['add_wheel', 'add_basement_rescue'];

function isHideReasonImageType(typeValue, typeLabel) {
    const value = String(typeValue || '');
    const label = String(typeLabel || '');
    if (HIDE_REASON_IMAGE_TYPES.includes(value)) {
        return true;
    }
    if (label.indexOf('仪表盘不亮') >= 0 || value.indexOf('仪表盘不亮') >= 0) {
        return true;
    }
    if (['hc_board', 'dashboard_off', 'board_dark', 'dashboard_dark'].includes(value)) {
        return true;
    }
    return false;
}

export default {
    name: 'orderReport',
    components: {
        orderReportDetail
    },
    props: {
        orderId: {
            type: [String, Number],
            default: ''
        },
        orderInfo: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            maxImageCount: 10,
            currentTab: 0,
            showDetail: false,
            currentRecord: null,
            typePickerShow: false,
            reportTypeOptions: [],
            reportTypeLabel: '',
            reportTypeValue: '',
            selectedTypeItem: null,
            extra: '',
            remark: '',
            imageList: [],
            recordList: [],
            listLoading: false,
            listRefreshing: false,
            submitting: false,
            detailRenderKey: 0,
            refreshCooldown: 0,
            refreshTimer: null,
            pushRefreshTimer: null
        };
    },
    computed: {
        popupHeightNum() {
            return Math.floor(window.innerHeight * 0.9);
        },
        popupHeight() {
            return this.popupHeightNum + 'px';
        },
        bodyHeight() {
            const headerH = 46;
            const tabsH = 44;
            const footerH = this.currentTab === 0 ? 70 : 0;
            return Math.floor(this.popupHeightNum - headerH - tabsH - footerH);
        },
        extraFieldConfig() {
            return EXTRA_FIELD_MAP[this.reportTypeValue] || null;
        },
        showReasonAndImages() {
            if (!this.reportTypeValue) {
                return true;
            }
            return !isHideReasonImageType(this.reportTypeValue, this.reportTypeLabel);
        },
        listScrollHeight() {
            return Math.floor(this.bodyHeight - 40);
        },
        refreshDisabled() {
            return this.refreshCooldown > 0 || this.listLoading || this.listRefreshing;
        },
        refreshBtnText() {
            if (this.listRefreshing) {
                return '刷新中';
            }
            if (this.refreshCooldown > 0) {
                return `${this.refreshCooldown}s`;
            }
            return '刷新';
        },
        reportTypeColumns() {
            return this.reportTypeOptions.map((item) => item.label);
        }
    },
    beforeDestroy() {
        this.clearRefreshTimer();
        this.clearPushRefreshTimer();
    },
    mounted() {
        this.initReport();
    },
    methods: {
        notifyBadgeRefresh() {
            this.$emit('badgeRefresh', this.recordList || []);
        },
        clearPushRefreshTimer() {
            if (this.pushRefreshTimer) {
                clearTimeout(this.pushRefreshTimer);
                this.pushRefreshTimer = null;
            }
        },
        refreshFromPush(payload = {}) {
            this.clearPushRefreshTimer();
            this.pushRefreshTimer = setTimeout(() => {
                this.pushRefreshTimer = null;
                this.handlePushRefresh(payload);
            }, 300);
        },
        async handlePushRefresh(payload = {}) {
            const { report_id, source, list } = payload;
            if (Array.isArray(list)) {
                this.recordList = list;
                if (this.showDetail && this.currentRecord) {
                    const found = list.find((item) => item.id == this.currentRecord.id);
                    if (found) {
                        this.currentRecord = { ...found };
                        this.detailRenderKey += 1;
                    }
                }
                this.notifyBadgeRefresh();
                return;
            }
            if (this.showDetail && report_id) {
                const currentId = this.currentRecord && this.currentRecord.id;
                if (String(currentId) === String(report_id)) {
                    await this.refreshReportDetail(report_id);
                    this.notifyBadgeRefresh();
                    return;
                }
            }
            if (this.currentTab === 1 || report_id || source === 'push') {
                await this.loadReportList();
                if (this.showDetail && this.currentRecord) {
                    const found = this.recordList.find((item) => item.id == this.currentRecord.id);
                    if (found) {
                        this.currentRecord = { ...found };
                        this.detailRenderKey += 1;
                    }
                }
            }
        },
        getOrderId() {
            return this.orderId || (this.orderInfo && this.orderInfo.id) || '';
        },
        getTypeLabel(item) {
            if (item.type && item.type !== item.typeValue) {
                return item.type;
            }
            const found = this.reportTypeOptions.find((type) => type.value === item.typeValue);
            return found ? found.label : (item.typeValue || item.type || '');
        },
        formatUnread(count) {
            const num = Number(count) || 0;
            return num > 99 ? '99+' : String(num);
        },
        getStatusStamp(item) {
            return getReportStatusStamp(item && item.status);
        },
        getStampImg(item) {
            const stamp = this.getStatusStamp(item);
            if (!stamp) {
                return '';
            }
            return stamp.stampImg || '';
        },
        async initReport() {
            await this.loadReportTypes();
            await this.loadReportList();
        },
        async loadReportTypes() {
            const orderId = this.getOrderId();
            if (!orderId) {
                return;
            }
            try {
                const res = await reportTypeList({ order_id: orderId });
                const types = normalizeReportTypes(res);
                if (types.length) {
                    this.reportTypeOptions = types;
                }
            } catch (err) {
                console.log('[report] loadReportTypes error', err);
            }
        },
        async loadReportList() {
            const orderId = this.getOrderId();
            if (!orderId) {
                return;
            }
            this.listLoading = true;
            try {
                const res = await getReport({ order_id: orderId });
                this.recordList = normalizeReportList(res, this.reportTypeOptions);
            } catch (err) {
                console.log('[report] loadReportList error', err);
                this.recordList = [];
            }
            this.listLoading = false;
            this.notifyBadgeRefresh();
        },
        async openReportById(reportId) {
            if (!reportId) {
                return;
            }
            if (!this.recordList.length) {
                await this.loadReportList();
            }
            const found = this.recordList.find((item) => String(item.id) === String(reportId));
            if (found) {
                this.currentTab = 1;
                await this.openDetail(found);
                return;
            }
            try {
                const res = await getReport({
                    order_id: this.getOrderId(),
                    report_id: reportId
                });
                const list = normalizeReportList(res, this.reportTypeOptions);
                if (list.length) {
                    this.recordList = list;
                    this.currentTab = 1;
                    await this.openDetail(list[0]);
                }
            } catch (err) {
                console.log('[report] openReportById error', err);
            }
        },
        switchTab(index) {
            this.currentTab = index;
            if (index === 1) {
                this.loadReportList();
            }
        },
        clearRefreshTimer() {
            if (this.refreshTimer) {
                clearInterval(this.refreshTimer);
                this.refreshTimer = null;
            }
        },
        startRefreshCooldown() {
            this.clearRefreshTimer();
            this.refreshCooldown = 10;
            this.refreshTimer = setInterval(() => {
                this.refreshCooldown -= 1;
                if (this.refreshCooldown <= 0) {
                    this.refreshCooldown = 0;
                    this.clearRefreshTimer();
                }
            }, 1000);
        },
        async handleRefreshList() {
            if (this.refreshDisabled) {
                return;
            }
            const orderId = this.getOrderId();
            if (!orderId) {
                return;
            }
            this.recordList = [];
            this.listRefreshing = true;
            try {
                const [res] = await Promise.all([
                    getReport({ order_id: orderId }),
                    new Promise((resolve) => setTimeout(resolve, 800))
                ]);
                this.recordList = normalizeReportList(res, this.reportTypeOptions);
            } catch (err) {
                console.log('[report] handleRefreshList error', err);
                this.recordList = [];
            }
            this.listRefreshing = false;
            this.startRefreshCooldown();
            this.notifyBadgeRefresh();
        },
        confirmType(value) {
            const item = this.reportTypeOptions.find((opt) => opt.label === value)
                || this.reportTypeOptions.find((opt) => opt.value === value);
            if (!item) {
                this.typePickerShow = false;
                return;
            }
            this.selectedTypeItem = item;
            this.reportTypeLabel = item.label || '';
            this.reportTypeValue = item.value || '';
            this.extra = '';
            if (isHideReasonImageType(this.reportTypeValue, this.reportTypeLabel)) {
                this.remark = '';
                this.imageList = [];
            }
            this.typePickerShow = false;
        },
        validateExtra() {
            const config = this.extraFieldConfig;
            if (!config) {
                return true;
            }
            const val = (this.extra || '').trim();
            if (!val) {
                Toast(`请输入${config.label}`);
                return false;
            }
            if (config.validateType === 'integer') {
                const num = Number(val);
                if (!Number.isInteger(num) || num < config.min || num > config.max) {
                    Toast(`${config.label}请输入${config.min}~${config.max}的整数`);
                    return false;
                }
            } else if (config.validateType === 'price') {
                const num = Number(val);
                if (isNaN(num) || num <= 0) {
                    Toast('请输入有效的议价价格');
                    return false;
                }
            }
            return true;
        },
        markReportRead(reportId) {
            const index = this.recordList.findIndex((record) => record.id == reportId);
            if (index >= 0) {
                this.$set(this.recordList, index, {
                    ...this.recordList[index],
                    unread: 0
                });
            }
            if (this.currentRecord && this.currentRecord.id == reportId) {
                this.currentRecord = {
                    ...this.currentRecord,
                    unread: 0
                };
            }
            this.notifyBadgeRefresh();
        },
        async openDetail(item) {
            Toast.loading({
                message: '加载中',
                forbidClick: true,
                duration: 0
            });
            try {
                const readPromise = item.is_done != 1 && item.unread > 0
                    ? reportRead({ report_id: item.id })
                        .then(() => this.markReportRead(item.id))
                        .catch((err) => {
                            console.log('[report] reportRead error', err);
                        })
                    : Promise.resolve();
                if (Array.isArray(item.messages) && item.messages.length) {
                    await readPromise;
                    this.currentRecord = item;
                } else {
                    const [res] = await Promise.all([
                        getReport({
                            order_id: this.getOrderId(),
                            report_id: item.id
                        }),
                        readPromise
                    ]);
                    this.currentRecord = normalizeReportDetail(res, item, this.reportTypeOptions);
                }
            } catch (err) {
                console.log('[report] openDetail error', err);
                this.currentRecord = item;
            }
            this.showDetail = true;
            Toast.clear();
        },
        async handleAgree(data) {
            Toast.loading({
                message: '处理中',
                forbidClick: true,
                duration: 0
            });
            try {
                await reportContentAgree({
                    content_id: data.content_id
                });
                await this.refreshReportDetail(data.report_id);
                Toast('已同意');
                this.notifyBadgeRefresh();
            } catch (err) {
                console.log('[report] handleAgree error', err);
                Toast((err && err.info) || '操作失败');
            }
        },
        async handleReply(data) {
            Toast.loading({
                message: '发送中',
                forbidClick: true,
                duration: 0
            });
            try {
                const images = data.images || [];
                let file = '';
                if (images.length) {
                    const urls = await uploadReportImages(images);
                    file = formatReportFiles(urls);
                }
                const params = {
                    report_id: data.id,
                    content: data.content || '',
                    file
                };
                if (data.extra !== undefined && data.extra !== null && data.extra !== '') {
                    params.extra = typeof data.extra === 'object'
                        ? String(data.extra.scalar || '')
                        : String(data.extra);
                }
                await reportReply(params);
                await this.refreshReportDetail(data.id);
                Toast('回复成功');
                this.notifyBadgeRefresh();
            } catch (err) {
                console.log('[report] handleReply error', err);
                Toast((err && err.info) || '回复失败');
            }
        },
        async refreshReportDetail(reportId) {
            try {
                const res = await getReport({ order_id: this.getOrderId() });
                const list = normalizeReportList(res, this.reportTypeOptions);
                const found = list.find((item) => item.id == reportId);
                if (found) {
                    this.currentRecord = { ...found };
                    this.detailRenderKey += 1;
                    const index = this.recordList.findIndex((item) => item.id == reportId);
                    if (index >= 0) {
                        this.$set(this.recordList, index, { ...found });
                    }
                }
            } catch (err) {
                console.log('[report] refreshReportDetail error', err);
            }
        },
        async handleCloseReport(data) {
            Toast.loading({
                message: '处理中',
                forbidClick: true,
                duration: 0
            });
            try {
                await reportClose({
                    report_id: data.report_id,
                    remark: data.remark
                });
                this.showDetail = false;
                this.currentRecord = null;
                await this.loadReportList();
                Toast('已取消报备');
            } catch (err) {
                console.log('[report] handleCloseReport error', err);
                Toast((err && err.info) || '取消失败');
            }
        },
        close() {
            this.$emit('close');
        },
        async submit() {
            if (!this.reportTypeValue) {
                Toast('请选择报备类型');
                return;
            }
            const hideReasonAndImages = isHideReasonImageType(this.reportTypeValue, this.reportTypeLabel);
            if (!hideReasonAndImages && !this.remark.trim()) {
                Toast('请输入上报原因');
                return;
            }
            if (!this.validateExtra()) {
                return;
            }
            if (this.submitting) {
                return;
            }
            this.submitting = true;
            Toast.loading({
                message: '提交中',
                forbidClick: true,
                duration: 0
            });
            try {
                let file = '';
                if (!hideReasonAndImages && this.imageList.length) {
                    const urls = await uploadReportImages(this.imageList);
                    file = formatReportFiles(urls);
                }
                const params = {
                    order_id: String(this.getOrderId()),
                    type: this.reportTypeValue,
                    content: hideReasonAndImages ? '' : this.remark.trim(),
                    file
                };
                if (this.extraFieldConfig) {
                    params.extra = JSON.stringify({ scalar: this.extra.trim() });
                }
                await createReport(params);
                this.reportTypeLabel = '';
                this.reportTypeValue = '';
                this.selectedTypeItem = null;
                this.extra = '';
                this.remark = '';
                this.imageList = [];
                this.currentTab = 1;
                await this.loadReportList();
                Toast('提交成功');
            } catch (err) {
                console.log('[report] submit error', err);
                Toast((err && err.info) || '提交失败');
            }
            this.submitting = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.report_com {
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    border-radius: 10px 10px 0 0;
    overflow: hidden;
}
.report_header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 14px 15px;
    position: relative;
    border-bottom: 1px solid #F0F0F0;
}
.report_title {
    color: #333333;
    font-size: 16px;
    font-weight: bold;
}
.close_icon {
    position: absolute;
    right: 12px;
    padding: 4px;
}
.report_tabs {
    display: flex;
    border-bottom: 1px solid #F0F0F0;
}
.tab_item {
    flex: 1;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 2px solid transparent;
}
.tab_item_active {
    border-bottom-color: #357EFE;
}
.tab_text {
    font-size: 15px;
    color: #707070;
}
.tab_text_active {
    color: #357EFE;
    font-weight: bold;
}
.report_body {
    overflow: hidden;
}
.form_scroll,
.list_scroll {
    width: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.list_panel {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.list_toolbar {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 15px;
    border-bottom: 1px solid #F0F0F0;
    background: #ffffff;
}
.refresh_btn {
    display: flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 14px;
    background: #F5F7FA;
}
.refresh_btn_disabled {
    opacity: 0.7;
}
.refresh_btn_text {
    margin-left: 4px;
    font-size: 13px;
    color: #357EFE;
}
.refresh_btn_text_disabled {
    color: #C0C4CC;
}
.spinning {
    animation: report_refresh_spin 0.8s linear infinite;
}
.form_content,
.list_content {
    padding: 12px 15px 15px;
    box-sizing: border-box;
}
.form_section {
    margin-bottom: 16px;
}
.section_title {
    font-size: 15px;
    color: #1F2129;
    margin-bottom: 10px;
}
.section_title_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.section_subtitle {
    font-size: 12px;
    color: #999999;
}
.picker_box {
    height: 44px;
    background: #F8F8F8;
    border-radius: 5px;
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.picker_placeholder {
    font-size: 14px;
    color: #999999;
}
.picker_value {
    font-size: 14px;
    color: #1F2129;
}
.extra_input_wrap {
    display: flex;
    align-items: center;
    background: #f7f8fa;
    border-radius: 4px;
    overflow: hidden;
}
.extra_input_wrap ::v-deep .van-field {
    flex: 1;
    background: transparent;
}
.extra_suffix {
    margin-right: 12px;
    font-size: 14px;
    color: #1F2129;
    flex-shrink: 0;
}
.record_card {
    position: relative;
    padding: 12px;
    margin-bottom: 10px;
    background: #ffffff;
    border: 1px solid #EBEEF5;
    border-radius: 6px;
    overflow: hidden;
    box-sizing: border-box;
}
.record_card_top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.record_card_top_has_unread {
    padding-right: 22px;
}
.record_type {
    font-size: 15px;
    color: #303133;
    font-weight: 500;
    flex: 1;
    padding-right: 8px;
}
.record_card_right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
    min-width: 40px;
}
.record_unread {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 2;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background: #F56C6C;
    border: 1px solid #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    box-shadow: 0 2px 5px rgba(245, 108, 108, 0.35);
}
.record_unread_text {
    font-size: 11px;
    color: #ffffff;
    line-height: 16px;
    font-weight: bold;
}
.record_card_bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.record_time {
    font-size: 12px;
    color: #909399;
}
.record_state_text {
    font-size: 12px;
    flex-shrink: 0;
}
.record_state_pending {
    color: #E6A23C;
}
.record_state_done {
    color: #909399;
}
.record_stamp_img {
    position: absolute;
    right: 6px;
    bottom: 4px;
    width: 60px;
    height: 60px;
    opacity: 0.92;
    pointer-events: none;
}
.list_empty {
    padding: 60px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.list_empty_text {
    font-size: 14px;
    color: #999999;
}
.list_refresh_text {
    margin-top: 12px;
}
@keyframes report_refresh_spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.report_footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 15px 16px;
    background: #ffffff;
    border-top: 1px solid #F0F0F0;
    box-sizing: border-box;
}
.footer_btn {
    width: 48%;
    height: 40px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.footer_btn_cancel {
    border: 1px solid #357EFE;
    box-sizing: border-box;
}
.footer_btn_submit {
    background: linear-gradient(90deg, #357EFE, #5B9BFF);
}
.footer_btn_text {
    font-size: 15px;
}
.footer_btn_cancel_text {
    color: #357EFE;
}
.footer_btn_submit_text {
    color: #ffffff;
}
</style>
